
import { useStore } from '../stores/store';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { t1aAdmin } from '../common/options/adminOptions';

export const RequiredAdminAuth = () => {
    const { userStore: { isLoggedIn, user } } = useStore();
    const location = useLocation();

    if (!isLoggedIn || !user || user!.currentUserRole !== t1aAdmin) {
        return <Navigate to="/" state={{ from: location }} />
    }

    return <Outlet />
}
